import React, { memo } from 'react';

import Banner from '../Banner/Banner';
import BannerRecommend from '../BannerRecommend/BannerRecommend';
import GroupRank from '../GroupRank/GroupRank';
import ImgRank from '../ImgRank/ImgRank';
import ImgRecommend from '../ImgRecommend/ImgRecommend';
import RankRecommend from '../RankRecommend/RankRecommend';
import ThreeColumnRank from '../ThreeColumnRank/ThreeColumnRank';
import OneColumnRank from '../OneColumnRank/OneColumnRank';
import HotSall from '../HotSall/HotSall';
import AdvertList from '../AdvertList/AdvertList';
import ImgOneLine from '../ImgOneLine/ImgOneLine';
import ZtList from '../ZtList/ZtList';
import ZtListAuto from '../ZtListAuto/ZtListAuto';

import WpBanner from '../WpBanner/WpBanner';
import WpReco from '../WpReco/WpReco';
import WpAuthorReco from '../WpAuthorReco/WpAuthorReco';

import ZtImg from '../ZtImg/ZtImg';
import ZtTitle from '../ZtTitle/ZtTitle';
import ZtText from '../ZtText/ZtText';
import ZtAppOne from '../ZtAppOne/ZtAppOne';

import SoftBanner from '../NS_SoftBanner/SoftBanner';
import MattsBanner from '../NS_MattsBanner/MattsBanner';
import ZtShowApp from '../NS_ZtShowApp/ZtShowApp';
import OneImg from '../NS_OneImg/OneImg';
import RankList from '../NS_RankList/RankList';
import ThreePart from '../NS_ThreePart/ThreePart';
import FourPart from '../NS_FourPart/FourPart';
import ThreePRank from '../NS_ThreePRank/ThreePRank';
import ThreePartAdvert from '../NS_ThreePartAdvert/ThreePartAdvert';
import RankListFour from '../NS_RankListFour/RankListFour';
import MattsBannerList from '../NS_MattsBannerList/MattsBannerList';
// v7.1
import CourseRankList from '../NS_CourseRankList/CourseRankList';
// v8.0
import SoftLine from '../NS_SoftLine/SoftLine';

// v7.0
import ZtTitleV2 from '../ZtTitle_V2/ZtTitle_V2';
import ZtRecoRate from '../ZtRecoRate/ZtRecoRate';
import ZtAppOneV2 from '../ZtAppOne_V2/ZtAppOne_V2';
import ZtAppList from '../ZtAppList/ZtAppList';
import ZtTextV2 from '../ZtText_V2/ZtText_V2';
import ZtVideo from '../ZtVideo/ZtVideo';
// v7.5
import GameBanner from '../GameBanner/GameBanner';
import GameBannerList from '../GameBannerList/GameBannerList';
import GameActivity from '../GameActivity/GameActivity';

// v8.6
import GameThreeRank from '../GameThreeRank/GameThreeRank';
import GameSoftLine8 from '../GameSoftLine8/GameSoftLine8';
import GameThreePart from '../GameThreePart/GameThreePart';
import GameInteract from '../GameInteract/GameInteract';
import GameZtListAuto from '../GameZtListAuto/GameZtListAuto';

export default memo(({ data, logInfo }) => {
  return (
    <React.Fragment>
      {/* 游戏banner */}
      {data.cardType === 'banner' && <Banner data={data} logInfo={logInfo} />}
      {/* 推荐页banner */}
      {data.cardType === 'banner_recommend' && <BannerRecommend data={data} logInfo={logInfo} />}
      {/* 推荐页本周最热 */}
      {data.cardType === 'one_column_rank' && <OneColumnRank data={data} logInfo={logInfo} />}
      {/* 矩阵应用列表 */}
      {data.cardType === 'group_rank' && <GroupRank data={data} logInfo={logInfo} />}
      {/* 矩阵大图应用列表 */}
      {data.cardType === 'img_rank' && <ImgRank data={data} logInfo={logInfo} />}
      {/* 游戏页推荐大图应用列表 */}
      {data.cardType === 'img_recommend' && <ImgRecommend data={data} logInfo={logInfo} />}
      {/* 推荐页推荐应用列表 */}
      {data.cardType === 'rank_recommend' && <RankRecommend data={data} logInfo={logInfo} />}
      {/* 三列榜单 */}
      {data.cardType === 'three_column_rank' && <ThreeColumnRank data={data} logInfo={logInfo} />}
      {/* {专题---列表} */}
      {data.cardType === 'zt_list' && <ZtList data={data} logInfo={logInfo} />}

      {/* 首页改版 专题---列表 v6.6 */}
      {data.cardType === 'zt_list_auto' && (!data.styleType || data.styleType === 1) && (
        <ZtListAuto data={data} logInfo={logInfo} />
      )}
      {/* 游戏改版  专题---列表  v8.6 */}
      {data.cardType === 'zt_list_auto' && data.styleType === 2 && (
        <GameZtListAuto data={data} logInfo={logInfo} />
      )}

      {/* {游戏---外部引流导购推荐} */}
      {data.cardType === 'advert' && <HotSall data={data} logInfo={logInfo} />}
      {/* {游戏---外部引流导购推荐 new} */}
      {data.cardType === 'advert_list' && <AdvertList data={data} logInfo={logInfo} />}
      {/* 搜索单行广告 */}
      {data.cardType === 'img_one_line' && <ImgOneLine data={data} logInfo={logInfo} />}
      {/* 壁纸banner */}
      {data.cardType === 'wallpaper_banner' && <WpBanner data={data} logInfo={logInfo} />}
      {/* 壁纸推荐 */}
      {data.cardType === 'wallpaper_recommend' && <WpReco data={data} logInfo={logInfo} />}
      {/* 壁纸作者推荐 */}
      {data.cardType === 'author_recommend' && <WpAuthorReco data={data} logInfo={logInfo} />}
      {/* 首页改版banner swiper  v6.6 */}
      {data.cardType === 'soft_banner' && <SoftBanner data={data} logInfo={logInfo} />}
      {/* 首页改版banner img  v6.6 */}
      {data.cardType === 'matts_banner' && <MattsBanner data={data} logInfo={logInfo} />}
      {/* 首页改版 一图专题+应用list v6.6 */}
      {data.cardType === 'zt_show_apps' && <ZtShowApp data={data} logInfo={logInfo} />}
      {/* 首页改版 一图专题 v6.6 */}
      {data.cardType === 'zt_one_img' && <OneImg data={data} logInfo={logInfo} />}
      {/* 首页改版 一应用list v6.6 */}
      {data.cardType === 'rank_list' && <RankList data={data} logInfo={logInfo} />}
      {/* 首页改版 一应用list v6.6 */}
      {data.cardType === 'rank_list_four_row' && (!data.styleType || data.styleType === 1) && (
        <RankListFour data={data} logInfo={logInfo} />
      )}
      {/* 游戏改版  一排8个应用  v8.6 */}
      {data.cardType === 'rank_list_four_row' && data.styleType === 2 && (
        <GameSoftLine8 data={data} logInfo={logInfo} />
      )}
      {/* 首页改版 三个应用图一排 v6.6 */}
      {data.cardType === 'three_parts' && (!data.styleType || data.styleType === 1) && (
        <ThreePart data={data} logInfo={logInfo} />
      )}
      {/* 游戏改版  三个应用图一排  v8.6 */}
      {data.cardType === 'three_parts' && data.styleType === 2 && (
        <GameThreePart data={data} logInfo={logInfo} />
      )}

      {/* 首页改版 四个应用图一排 v6.6 */}
      {data.cardType === 'four_parts' && <FourPart data={data} logInfo={logInfo} />}
      {/* 首页改版 三列榜单 v6.6 */}
      {data.cardType === 'three_personalized_rank' && (!data.styleType || data.styleType === 1) && (
        <ThreePRank data={data} logInfo={logInfo} />
      )}

      {data.cardType === 'three_personalized_rank' && data.styleType === 2 && (
        <GameThreeRank data={data} logInfo={logInfo} />
      )}

      {/* 首页改版 三图广告，可以左右滑动 v6.6 */}
      {(data.cardType === 'advert_three_parts' || data.cardType === 'advert_list_three_parts') && (
        <ThreePartAdvert data={data} logInfo={logInfo} />
      )}
      {/* 首页改版 首页banner右边的card v6.6 */}
      {data.cardType === 'matts_banner_list' && <MattsBannerList data={data} logInfo={logInfo} />}

      {/** v7.1教育新增 */}
      {data.cardType === 'course_rank_list_parts' && (
        <CourseRankList data={data} logInfo={logInfo} />
      )}
      {/* {v7.5 游戏} */}
      {data.cardType === 'game_banner' && <GameBanner data={data} logInfo={logInfo} />}
      {data.cardType === 'banner_list' && <GameBannerList data={data} logInfo={logInfo} />}
      {/* 游戏活动中图片card */}
      {data.cardType === 'activity_banner' && <GameActivity data={data} logInfo={logInfo} />}
      {/** v8.0升级新增 */}
      {data.cardType === 'single_soft_list' && <SoftLine data={data} logInfo={logInfo} />}

      {/** v8.6 游戏互动筛选 */}
      {data.cardType === 'interact_show_list' && <GameInteract data={data} logInfo={logInfo} />}

      {/********************************************************************************************************************************************/}

      {/********************  以下是专题详情页面的专题小卡片 ************************/}
      {/* 专题大图 */}
      {data.contentType === 'zt_img' && <ZtImg data={data} logInfo={logInfo} />}
      {/* 专题标题 */}
      {data.contentType === 'zt_title' && <ZtTitle data={data} logInfo={logInfo} />}
      {/* 专题text描述 */}
      {(data.contentType === 'zt_text' || data.contentType === 'zt_html') && (
        <ZtText data={data} logInfo={logInfo} />
      )}
      {/* 专题单行app */}
      {data.contentType === 'zt_app_one' && <ZtAppOne data={data} logInfo={logInfo} />}
      {/* v7.0新增专题 */}
      {data.contentType === 'zt_title_v2' && <ZtTitleV2 data={data} logInfo={logInfo} />}
      {data.contentType === 'zt_recommend_rate' && <ZtRecoRate data={data} logInfo={logInfo} />}
      {data.contentType === 'zt_app_one_v2' && <ZtAppOneV2 data={data} logInfo={logInfo} />}
      {data.contentType === 'zt_app_list' && <ZtAppList data={data} logInfo={logInfo} />}
      {data.contentType === 'zt_text_v2' && <ZtTextV2 data={data} logInfo={logInfo} />}
      {data.contentType === 'zt_video' && <ZtVideo data={data} logInfo={logInfo} />}
      {/********************  ************************  ************************/}
    </React.Fragment>
  );
});
